import type { ReactNode } from "react";
import type { TagTone } from "@/mocks/homeData";

const toneMap: Record<TagTone, { pill: string; dot: string }> = {
  accent: {
    pill: "bg-accent-100 text-accent-800 border-accent-200/70",
    dot: "bg-accent-500",
  },
  secondary: {
    pill: "bg-secondary-100 text-secondary-900 border-secondary-200",
    dot: "bg-secondary-500",
  },
  primary: {
    pill: "bg-foreground-100 text-foreground-800 border-foreground-200",
    dot: "bg-foreground-800",
  },
};

export function TagPill({ tone, children }: { tone: TagTone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${toneMap[tone].pill}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${toneMap[tone].dot}`} />
      {children}
    </span>
  );
}

export function SectionHead({
  kicker,
  title,
  extra,
  tone = "primary",
  id,
}: {
  kicker: string;
  title: string;
  extra?: ReactNode;
  tone?: TagTone;
  id?: string;
}) {
  const barColor = toneMap[tone].dot;
  return (
    <div id={id} className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className={`h-6 w-1.5 rounded-full ${barColor}`} />
        <div>
          <p className="font-label text-[11px] font-medium tracking-[0.28em] text-foreground-400">
            {kicker}
          </p>
          <h2 className="mt-0.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
        </div>
      </div>
      {extra}
    </div>
  );
}